import type { Plan } from "@circle-react/types";

import { Button } from "@/react/components/SettingsApp/CompassCompat/Button";
import { classNames } from "@/react/helpers/twMergeWithCN";

import { useSubmitButton } from "./useSubmitButton";

export interface SubmitButtonProps {
  plan: Plan;
}

export const SubmitButton = ({ plan }: SubmitButtonProps) => {
  const buttonConfig = useSubmitButton(plan);

  return (
    <Button
      variant={buttonConfig.variant}
      extraLarge
      full
      onClick={buttonConfig.handler}
      disabled={buttonConfig.disabled}
      startIcon={buttonConfig.startIcon}
      data-testid={buttonConfig.testId}
      className={classNames("w-full", buttonConfig.className)}
    >
      {buttonConfig.text}
    </Button>
  );
};
